import { render, staticRenderFns } from "./EditedRemittances.vue?vue&type=template&id=2215b9d5&"
import script from "./EditedRemittances.vue?vue&type=script&lang=js&"
export * from "./EditedRemittances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports